import { render, staticRenderFns } from "./ChartXLTJ_Charge.vue?vue&type=template&id=65d392a4&scoped=true&"
import script from "./ChartXLTJ_Charge.vue?vue&type=script&lang=js&"
export * from "./ChartXLTJ_Charge.vue?vue&type=script&lang=js&"
import style0 from "./ChartXLTJ_Charge.vue?vue&type=style&index=0&id=65d392a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d392a4",
  null
  
)

export default component.exports